/**
 * School Log Service Provider
 *
 * This service provider determines whether to use mock or real school log services
 * based on the environment configuration.
 */

import * as mockSchoolLogService from "./mock-school-log.service";
import * as realSchoolLogService from "./school-log.service";

// Check if we should use mock services based on environment variable
const useMockServices = false; // import.meta.env.VITE_USE_MOCK_SCHOOL_LOGS !== "false";

// Export the appropriate service functions based on the configuration
export const getAllSchoolLogsService = useMockServices
  ? mockSchoolLogService.getAllSchoolLogsService
  : realSchoolLogService.getAllSchoolLogsService;

export const getSchoolLogService = useMockServices
  ? mockSchoolLogService.getSchoolLogService
  : realSchoolLogService.getSchoolLogService;

// Re-export types from the types folder
export type { SchoolLogModel, SchoolLogQuery } from "@/types/school-log.model";
